import { ThemeConfig } from "antd";

export default {
  components: {
    Menu: {
      colorItemBgSelected: "#00AA861A",
      colorItemText: "black",
      colorItemTextSelected: "black",
      colorItemBg: "white",
      colorSubItemBg: "white",
      colorItemBgHover: "#00AA861A",
    },
    Button: {
      defaultColor: "#9448FF",
    },
    Form: {
      labelFontSize: 14,
    },
    Table: {
      rowHoverBg: "#fcf8ff",
      rowSelectedBg: "#fcf8ff",
      rowSelectedHoverBg: "#f6ebff",
    },
  },
  token: {
    colorPrimary: "#8A44ED",
    colorPrimaryBg: "#F1F2F4",
    colorInfo: "#016987",
    colorInfoHover: "#016987",
    colorInfoActive: "#016987",
    fontFamily: "Noto Sans Thai Looped, Noto Sans, sans-serif",
    fontSize: 16,
    colorBorder: "#9448FF",
    fontSizeHeading1: 26,
    fontWeightStrong: 500,
    controlHeightLG: 45,
  },
} as ThemeConfig;
